export const getRole = () => {
  return localStorage.getItem("role");
};
export const getPermissions = () => {
  const stored = localStorage.getItem("permissions");
  return stored ? JSON.parse(stored) : {};
};
export const hasPermission = (key) => {
  const role = getRole();
  const permissions = getPermissions();
  // SUPER_ADMIN → Always true
  if (role === "SUPER_ADMIN") return true;
  return permissions[key] === true;
};
